module.exports = __webpack_public_path__ + "static/img/banner.e0d7c709.jpg";